import React from 'react';

export default function HeroPanel() {
  return (
    <section className="scroll-panel grid-bg-subtle" style={{ background: 'var(--washi)' }}>
      <div className="noise-overlay" />
      {/* Full panel layout */}
      <div className="w-full h-full flex flex-col md:flex-row items-stretch pt-16 pb-12">

        {/* LEFT: Collage composition */}
        <div
          className="relative flex-shrink-0 md:w-[52%] h-64 md:h-full"
          style={{ minHeight: '320px' }}
        >
          {/* Boarding pass stub */}
          <div
            className="boarding-pass paper-element absolute font-plex-mono"
            style={{
              top: '12%',
              left: '8%',
              width: '220px',
              padding: '14px 16px',
              transform: 'rotate(-3.5deg)',
              zIndex: 3,
            }}
          >
            <div style={{ fontSize: '8px', letterSpacing: '0.2em', color: 'var(--tatami)', textTransform: 'uppercase', marginBottom: '6px' }}>Boarding Pass</div>
            <div style={{ fontSize: '18px', fontWeight: 600, color: 'var(--sumi)', letterSpacing: '0.05em' }}>ICN ✈ JFK</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px' }}>
              <div>
                <div style={{ fontSize: '7px', color: 'var(--tatami)', textTransform: 'uppercase', letterSpacing: '0.15em' }}>Passenger</div>
                <div style={{ fontSize: '10px', color: 'var(--sumi)', marginTop: '2px' }}>STUDENT / ONE WAY</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: '7px', color: 'var(--tatami)', textTransform: 'uppercase', letterSpacing: '0.15em' }}>Seat</div>
                <div style={{ fontSize: '10px', color: 'var(--sumi)', marginTop: '2px' }}>34A</div>
              </div>
            </div>
            <div style={{ marginTop: '10px', paddingTop: '8px', borderTop: '1px dashed rgba(184,175,166,0.5)', display: 'flex', gap: '4px' }}>
              {Array.from({ length: 18 })?.map((_, i) => (
                <div key={i} style={{ width: '2px', height: '24px', background: i % 3 === 0 ? 'var(--sumi)' : 'rgba(26,26,26,0.4)', borderRadius: '1px' }} />
              ))}
            </div>
          </div>

          {/* Tape on boarding pass */}
          <div className="tape-strip" style={{ top: '10%', left: '6%', width: '60px', transform: 'rotate(-3.5deg)', zIndex: 12 }} />

          {/* Handwritten packing list */}
          <div
            className="paper-element absolute"
            style={{
              top: '28%',
              left: '42%',
              width: '160px',
              padding: '14px 16px',
              transform: 'rotate(2.8deg)',
              zIndex: 5,
              background: '#fefcf7',
              lineHeight: 1.8,
            }}
          >
            <div style={{ fontSize: '9px', fontFamily: 'IBM Plex Mono', letterSpacing: '0.15em', color: 'var(--tatami)', textTransform: 'uppercase', marginBottom: '8px' }}>Packing List</div>
            {['passport ✓', 'adapter plug ✓', 'IELTS cert ✓', 'euros (€400)', 'housing deposit', 'student visa', 'return ticket?']?.map((item, i) => (
              <div key={i} style={{ fontSize: '11px', fontFamily: 'Fraunces, serif', fontStyle: 'italic', color: i < 3 ? 'var(--tatami)' : 'var(--sumi)', textDecoration: i < 3 ? 'line-through' : 'none', marginBottom: '2px' }}>
                {item}
              </div>
            ))}
          </div>

          {/* Tape on packing list */}
          <div className="tape-strip" style={{ top: '26.5%', left: '48%', width: '50px', transform: 'rotate(2.8deg)', zIndex: 14 }} />

          {/* University acceptance letter fragment */}
          <div
            className="letter-paper paper-element absolute"
            style={{
              top: '55%',
              left: '5%',
              width: '240px',
              padding: '16px 18px',
              transform: 'rotate(1.2deg)',
              zIndex: 4,
            }}
          >
            <div style={{ fontSize: '8px', fontFamily: 'IBM Plex Mono', letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--tatami)', marginBottom: '8px' }}>Office of Admissions</div>
            <div style={{ fontSize: '12px', fontFamily: 'Fraunces, serif', fontWeight: 600, color: 'var(--sumi)', marginBottom: '6px' }}>Dear Applicant,</div>
            <div style={{ fontSize: '10px', color: 'var(--sumi-light)', lineHeight: 1.6, marginBottom: '6px' }}>
              We are pleased to inform you of your acceptance to the International Exchange Programme for the academic year 2026–27...
            </div>
            <div style={{ fontSize: '9px', fontFamily: 'Fraunces, serif', fontStyle: 'italic', color: 'var(--vermillion)', marginTop: '8px' }}>
              — Yonsei University, Seoul
            </div>
          </div>

          {/* Tape on letter */}
          <div className="tape-strip" style={{ top: '53.5%', left: '10%', width: '55px', transform: 'rotate(1.2deg)', zIndex: 12 }} />

          {/* Passport photo booth strip */}
          <div
            className="photo-strip paper-element absolute"
            style={{
              top: '8%',
              left: '62%',
              width: '72px',
              transform: 'rotate(-1.5deg)',
              zIndex: 6,
              padding: '4px 4px 8px',
            }}
          >
            {[
              'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=80&h=80&fit=crop&crop=face',
              'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=80&h=80&fit=crop&crop=face',
              'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=80&h=80&fit=crop&crop=face',
              'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=80&h=80&fit=crop&crop=face',
            ]?.map((_, i) => (
              <div key={i} style={{ width: '64px', height: '64px', background: '#d4cec8', marginBottom: '3px', overflow: 'hidden', filter: 'grayscale(20%)' }}>
                <img
                  src={`https://images.unsplash.com/photo-${i % 2 === 0 ? '1529626455594-4ff0802cfb7e' : '1517841905240-472988babdf9'}?w=80&h=80&fit=crop&crop=face`}
                  alt="Passport photo"
                  style={{ width: '100%', height: '100%', objectFit: 'cover', filter: 'sepia(10%) grayscale(15%)' }}
                />
              </div>
            ))}
            <div style={{ fontSize: '7px', fontFamily: 'IBM Plex Mono', color: 'var(--tatami)', textAlign: 'center', marginTop: '4px', letterSpacing: '0.1em' }}>PHOTO ID</div>
          </div>

          {/* Tape on photo strip */}
          <div className="tape-strip" style={{ top: '6.5%', left: '63%', width: '45px', transform: 'rotate(-1.5deg)', zIndex: 14 }} />

          {/* Map with circled city */}
          <div
            className="map-element paper-element absolute"
            style={{
              top: '42%',
              left: '60%',
              width: '160px',
              height: '120px',
              transform: 'rotate(2deg)',
              zIndex: 3,
              overflow: 'hidden',
            }}
          >
            {/* SVG mini map abstraction */}
            <svg viewBox="0 0 160 120" style={{ width: '100%', height: '100%' }}>
              {/* Background */}
              <rect width="160" height="120" fill="#e0dbd0" />
              {/* Abstract coastlines */}
              <path d="M20 30 Q40 20 60 35 Q80 45 100 30 Q120 18 140 28 L140 80 Q120 75 100 85 Q80 95 60 82 Q40 70 20 78 Z" fill="#d4cdc2" stroke="rgba(184,175,166,0.6)" strokeWidth="0.5"/>
              <path d="M0 50 Q15 45 30 55 Q45 65 60 55" fill="none" stroke="rgba(184,175,166,0.8)" strokeWidth="1"/>
              {/* City dots */}
              {[[40, 45], [90, 35], [120, 55], [65, 70], [110, 80]]?.map(([cx, cy], i) => (
                <circle key={i} cx={cx} cy={cy} r="2" fill="rgba(26,26,26,0.4)" />
              ))}
              {/* Circled city (Seoul) */}
              <circle cx="90" cy="35" r="10" fill="none" stroke="var(--vermillion)" strokeWidth="1.5" strokeDasharray="3,2"/>
              <circle cx="90" cy="35" r="2.5" fill="var(--vermillion)" opacity="0.8"/>
              {/* Label */}
              <text x="103" y="32" fontSize="7" fontFamily="IBM Plex Mono" fill="var(--vermillion)" opacity="0.9">Seoul</text>
              {/* Grid lines */}
              {[30, 60, 90]?.map(x => (
                <line key={x} x1={x} y1="0" x2={x} y2="120" stroke="rgba(184,175,166,0.25)" strokeWidth="0.5"/>
              ))}
              {[30, 60, 90]?.map(y => (
                <line key={y} x1="0" y1={y} x2="160" y2={y} stroke="rgba(184,175,166,0.25)" strokeWidth="0.5"/>
              ))}
            </svg>
            <div style={{ position: 'absolute', bottom: '4px', right: '6px', fontSize: '7px', fontFamily: 'IBM Plex Mono', color: 'var(--tatami)', letterSpacing: '0.1em' }}>
              2026 ↗
            </div>
          </div>

          {/* Tape on map */}
          <div className="tape-strip" style={{ top: '40.5%', left: '66%', width: '40px', transform: 'rotate(2deg)', zIndex: 12 }} />

          {/* Visa stamp */}
          <div style={{ position: 'absolute', bottom: '15%', left: '38%', zIndex: 8 }}>
            <div className="stamp">APPROVED</div>
          </div>

          {/* Thin vertical rule separating collage from text */}
          <div
            className="hidden md:block absolute right-0 top-0 bottom-0"
            style={{ width: '1px', background: 'linear-gradient(to bottom, transparent, rgba(184,175,166,0.5), transparent)' }}
          />
        </div>

        {/* RIGHT: Editorial headline + meta */}
        <div className="flex-1 flex flex-col justify-center px-8 md:px-12 lg:px-16 py-8 md:py-0">
          <div className="panel-content">
            {/* Section label */}
            <div className="section-label mb-6" style={{ color: 'var(--tatami)' }}>
              Vol. 04 — February 2026
            </div>

            {/* Massive headline */}
            <h1
              className="font-fraunces font-medium leading-tight mb-6"
              style={{ fontSize: 'clamp(2.2rem, 4.5vw, 4rem)', color: 'var(--sumi)', letterSpacing: '-0.02em', maxWidth: '560px' }}
            >
              What{' '}
              <span style={{ fontStyle: 'italic' }}>11,000 students</span>{' '}
              wish they knew<br />
              before they left.
            </h1>

            {/* Thin rule */}
            <hr className="tatami-rule mb-6" style={{ maxWidth: '320px' }} />

            {/* Subhead */}
            <p
              className="font-dm-sans mb-8"
              style={{ fontSize: '15px', color: 'var(--sumi-light)', lineHeight: 1.7, maxWidth: '420px', fontWeight: 300 }}
            >
              Visa approval rates. Housing deposits in euros.
              Credit transfers that never happened. This is the data
              your university brochure left out.
            </p>

            {/* Pull quote teaser */}
            <div className="pull-quote mb-8" style={{ maxWidth: '380px' }}>
              <p
                className="font-fraunces"
                style={{ fontSize: '15px', fontStyle: 'italic', color: 'var(--sumi)', lineHeight: 1.65 }}
              >
                "I spent six weeks refreshing Reddit. I wish I'd had
                this before I booked the flight."
              </p>
              <div className="section-label mt-2" style={{ color: 'var(--tatami)' }}>
                — Priya M., studying in Berlin
              </div>
            </div>

            {/* Scroll instruction */}
            <div className="flex items-center gap-4">
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <svg width="32" height="16" viewBox="0 0 32 16" fill="none">
                  <rect x="0.5" y="0.5" width="31" height="15" rx="7.5" stroke="var(--tatami)" strokeWidth="1"/>
                  <circle cx="10" cy="8" r="2.5" fill="var(--sumi)" opacity="0.5"/>
                </svg>
                <span className="section-label">Scroll to explore</span>
              </div>
              <svg width="20" height="12" viewBox="0 0 20 12" fill="none" style={{ opacity: 0.4 }}>
                <path d="M1 6H19M14 1L19 6L14 11" stroke="var(--sumi)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}